import React from 'react';
import { ThemeProviderV4, StyledEngineProvider, StylesProviderV4, ThemeProvider } from '~/lib/bn-material-ui';
import { muiTheme, generateClassName } from '~/utility/BinSentry-ui-utility';
import ManufacturersCapacity from '../../bins/level-history/manufacturers-capacity/manufacturers-capacity';

export function manufacturersCapacityParcel(props) {
  return (
    <StyledEngineProvider generateClassName={generateClassName} injectFirst>
      <StylesProviderV4 generateClassName={generateClassName}>
        <ThemeProvider theme={muiTheme}>
          <ThemeProviderV4 theme={muiTheme}>
            <ManufacturersCapacity
              show={props.show}
              handleClose={props.handleClose}
              href={props.href}
              oldCapacity={props.capacity}
            />
          </ThemeProviderV4>
        </ThemeProvider>
      </StylesProviderV4>
    </StyledEngineProvider>
  );
}
